import { IAppState } from '../app.state';
 
export const selectPaymentFractions = (state: IAppState) => [...state.paymentFractions.list];
export const selectSelectedPaymentFractions = (state: IAppState) => state.paymentFractions.selected;